import { render } from "./RecuperarView.vue?vue&type=template&id=180701d0&scoped=true"
import script from "./RecuperarView.vue?vue&type=script&lang=js"
export * from "./RecuperarView.vue?vue&type=script&lang=js"

import "./RecuperarView.vue?vue&type=style&index=0&id=180701d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180701d0"]])

export default __exports__